import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

const NotFoundPageStyled = {
  wrapper: css``,

  header: css`
    display: none;
    ${media.md} {
      display: block;
    }
  `,

  mainContent: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    gap: 16px;

    padding: 128px 20px 45px 20px;

    img {
      max-width: 300px;
    }

    h2 {
      color: #1c1c1e;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  `,

  describe: css`
    color: #636369;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;

    max-width: 411px;
  `,

  btn: css`
    width: 100%;
    text-align: center;
    button {
      height: 44px;
      width: 120px;
      ${media.md} {
        width: 100%;
      }

      border-radius: 8px;
      background-color: ${theme.colors.darkGreen};
      &:hover {
        background-color: ${theme.colors.lightText} !important;
      }
      span {
        color: #faf5ff;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
  `,
};

export default NotFoundPageStyled;
